import { http } from "./http";

export type EventoAdmin = {
  id: number;
  nombre: string;
  slug: string;
  fechaPrincipal: string; // ISO
  fechaLimiteRsvp: string; // ISO
  zonaHoraria: string;
  estado: EventoEstado;
  creadoEn: string;
  creadoPorUsuarioId: number;
  admins: EventoAdminUser[];
};

export type EventoEstado = "PLANIFICADO" | "ENVIADO" | "TERMINADO" | "CANCELADO" | string;

export type EventoAdminUser = {
  usuarioId: number;
  nombre: string;
  email: string;
  rolEvento: string; // "OWNER" | "ADMIN" ...
};

export type CrearEventoRequest = {
  nombre: string;
  slug: string;
  fechaPrincipal: string; // ISO
  fechaLimiteRsvp: string; // ISO
  zonaHoraria: string;
};

export type ActualizarEventoRequest = {
  nombre: string;
  slug: string;
  fechaPrincipal: string; // ISO
  fechaLimiteRsvp: string; // ISO
  zonaHoraria: string;
  estado: EventoEstado;
};

export async function listarEventos() {
  return http.request<EventoAdmin[]>("/api/admin/eventos", { method: "GET" });
}

export async function crearEvento(payload: CrearEventoRequest) {
  return http.request<EventoAdmin>("/api/admin/eventos", {
    method: "POST",
    body: payload,
  });
}

export async function obtenerEvento(id: number) {
  return http.request<EventoAdmin>(`/api/admin/eventos/${id}`, { method: "GET" });
}

export async function actualizarEvento(id: number, payload: ActualizarEventoRequest) {
  return http.request<EventoAdmin>(`/api/admin/eventos/${id}`, {
    method: "PUT",
    body: payload,
  });
}

export async function asignarAdminEvento(eventoId: number, usuarioId: number, rolEvento: string) {
  await http.request<void>(`/api/admin/eventos/${eventoId}/admins`, {
    method: "POST",
    body: { usuarioId, rolEvento },
  });
}

export async function eliminarAdminEvento(eventoId: number, usuarioId: number) {
  await http.request<void>(`/api/admin/eventos/${eventoId}/admins/${usuarioId}`, {
    method: "DELETE",
  });
}
